export default __webpack_public_path__ + "static/media/report.7c64fd9e.svg";